/* eslint-disable @typescript-eslint/naming-convention */
import { useRouter } from "next/router";
import { LandingPageEvent } from "~/common/constants";
import { useAnalytics } from "~/components/Analytics";
import { FeatureWithDemo as FeatureWithDemoBlock } from "~/components/LandingPage/schemas";
import { useToastManager } from "~/components/ToastManager";
import { FeatureWithDemoCentered } from "~/landing-pages/components/Feature/FeatureWithDemoCentered";
import { FeatureWithDemoSplit } from "~/landing-pages/components/Feature/FeatureWithDemoSplit";
import { requestDemo } from "~/lib/client/endilApiCalls";
import { RequestDemoFormSchema } from "~/lib/shared/schemas/requestDemoSchema";

export type FeatureWithDemoImplementationProps = FeatureWithDemoBlock;

export const FeatureWithDemoImplementation: React.FC<
  FeatureWithDemoImplementationProps
> = ({ layout, successMessage, successRedirectUrl, ...rest }) => {
  const { analyticsEnhancedTrack } = useAnalytics();
  const { addToast } = useToastManager();
  const { asPath, push, query } = useRouter();

  const {
    campaignId,
    utm_source,
    utm_medium,
    utm_campaign,
    utm_term,
    utm_content,
  } = query;

  const onFormSubmit = async (values: RequestDemoFormSchema) => {
    analyticsEnhancedTrack(LandingPageEvent.REQUEST_DEMO_FORM_SUBMIT);

    await requestDemo({
      ...values,
      eventName: LandingPageEvent.REQUEST_DEMO_FORM_SUBMIT,
      pageUrl: asPath.split("?")[0],
      iterableCampaignId: campaignId,
      utmSource: utm_source,
      utmMedium: utm_medium,
      utmCampaign: utm_campaign,
      utmTerm: utm_term,
      utmContent: utm_content,
    });

    addToast("success", successMessage);
    push(successRedirectUrl.url);
  };

  if (layout === "centered") {
    return <FeatureWithDemoCentered {...rest} onFormSubmit={onFormSubmit} />;
  }

  if (layout === "split") {
    return <FeatureWithDemoSplit {...rest} onFormSubmit={onFormSubmit} />;
  }

  return null;
};
